export default "__VITE_ASSET__dc568744__"